<template>
    <Dialog v-model:visible="localVisible" modal :header="'Payment Warning'" :style="{ width: '30rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" @hide="handleClose">
        <div class="payment-dialog-content">
            <p class="mb-3">{{ message }}</p>
        </div>
        <template #footer>
            <div class="d-flex justify-content-center" style="flex-wrap: nowrap; gap: 10px;">
                <button type="button" class="backbutton btn" @click="handleCancel">Cancel</button>
                <button type="button" class="nextbutton btn" @click="handleContinue">Continue</button>
            </div>
        </template>
    </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";

export default {
    name: 'PaymentInProgressDialog',
    components: {
        Dialog,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false
        },
        message: {
            type: String,
            required: true,
            default: "A payment is currently in progress. Initiating a new payment may result in duplicate transactions. Do you want to continue?"
        }
    },
    data() {
        return {
            localVisible: this.visible
        };
    },
    watch: {
        visible(val) {
            this.localVisible = val;
        },
        localVisible(val) {
            if (!val) {
                this.$emit('update:visible', false);
            }
        }
    },
    methods: {
        handleClose() {
            this.localVisible = false;
            this.$emit('handleCancel');
        },
        handleContinue() {
            this.localVisible = false;
            this.$emit('handleContinue');
        },
        handleCancel() {
            this.localVisible = false;
            this.$emit('handleCancel');
        }
    }
};
</script>

<style scoped>
.payment-dialog-content {
    padding: 0.5rem 0;
}
</style>
